module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "myflex",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('img', {
    staticClass: "logoimg",
    attrs: {
      "src": require("./../assets/img/MyFireBase.svg"),
      "alt": "MyfirebaseLogo"
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('p', {
    staticClass: "display-1 font-weight-thin"
  }, [_vm._v("Добро пожаловать на платформу для инвестирования в реальный бизнес\n      ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-114920c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
// module id = 461
// module chunks = 1